/**
 * Subscriber milestones for the Newsletter Admin dashboard.
 * Shared between the visual tracker and the celebration hook.
 */
export const MILESTONES = [
  { count: 25, label: "Primer núcleo", emoji: "🌱" },
  { count: 50, label: "Comunidad inicial", emoji: "🌿" },
  { count: 100, label: "Cien suscriptoras", emoji: "✨" },
  { count: 250, label: "Comunidad sólida", emoji: "🌳" },
  { count: 500, label: "Quinientas voces", emoji: "🔥" },
  { count: 1000, label: "Mil suscriptoras", emoji: "🏆" },
  { count: 2500, label: "Referente nacional", emoji: "⭐" },
  { count: 5000, label: "Referente internacional", emoji: "🌍" },
];

/** Last milestone the user has already passed (or null). */
export const getLastAchieved = (count) => {
  const passed = MILESTONES.filter((m) => count >= m.count);
  return passed[passed.length - 1] || null;
};

/** Next milestone to reach (or null if everything is done). */
export const getNext = (count) => MILESTONES.find((m) => count < m.count) || null;

/** Returns the milestone newly crossed between `prev` and `current` (or null). */
export const findCrossedMilestone = (prev, current) =>
  MILESTONES.find((m) => prev < m.count && current >= m.count) || null;

/** Hand-written celebration copy per milestone (used by the banner). */
export const CELEBRATION_COPY = {
  25: "Tu primer núcleo está formado. La gente que más te necesita ya te lee.",
  50: "Cincuenta personas eligen tu voz una vez al mes. Ya es comunidad.",
  100: "Cien suscriptoras. Cada envío llega a cien personas que quieren oírte.",
  250: "Doscientas cincuenta. Una sala entera te lee cada mes.",
  500: "Quinientas voces escuchándote. Tu trabajo está resonando muy lejos.",
  1000: "MIL suscriptoras. Mil personas con cáncer, fibromialgia o fatiga reciben tu newsletter.",
  2500: "Referente nacional. Eres una voz que importa en tu campo en España.",
  5000: "Referente internacional. Tu método cruza fronteras.",
};
